@import 'ui-cms-spacing';

:host {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
}

:host(.positive-value) {
  color: var(--skin-color-primary, $sd-textColor-primary-DEFAULT);
  border: 1px dashed var(--skin-color-primary, $sd-textColor-primary-DEFAULT);
}

:host(.negative-value) {
  color: $sd-textColor-error;
  border: 1px dashed $sd-borderColor-error-DEFAULT;
}

:host([inverted]) {
  color: var(--skin-color-primary-inverted, $sd-textColor-white);
  border: 1px dashed var(--skin-color-primary-inverted, $sd-textColor-white);
}
